import { useTranslation } from 'react-i18next';
import { match } from 'ts-pattern';

import { LinkButton } from '~/components';
import { routes } from '~/providers/RouterProvider/router.routes';

import { buttonStyle } from './PreviousStepButton.css';

type Props = {
  to: 'vatNumber' | 'accountInformation';
};

export const PreviousStepButton = ({ to }: Props) => {
  const { t } = useTranslation(['auth']);

  return (
    <LinkButton
      className={buttonStyle}
      emphasis="tertiary"
      icon="ArrowLeft"
      to={match(to)
        .with('vatNumber', () => routes.register)
        .with('accountInformation', () => routes.registerAccountInformation)
        .exhaustive()}
    >
      {t('auth:registrationPage.common.previousStepButton')}
    </LinkButton>
  );
};
